import useKlydoQuery, {
  UseKlydoQueryResult,
} from '../../../hooks/useKlydoQuery';
import calendarEventApiClient, {
  CalendarEvent,
} from '../../../api/calendarEvent';

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

type UseCalendarEventsQueryParams = {
  country: string;
  year: number;
  state?: string;
  /**
   * Lets a caller hold the fetch back until it is actually needed. `PublishModal`
   * is rendered unconditionally by the klydo views, so without this the events were
   * fetched on every klydo page load whether or not the modal was ever opened.
   */
  enabled?: boolean;
};

const useCalendarEventsQuery = ({
  country,
  year,
  state,
  enabled = true,
}: UseCalendarEventsQueryParams): UseKlydoQueryResult<CalendarEvent[]> => {
  return useKlydoQuery({
    queryKey: ['calendar-events', country, year, state],
    queryFn: () =>
      calendarEventApiClient.getCalendarEvents(country, year, state),
    enabled: enabled && !!country && typeof year === 'number',
    gcTime: ONE_DAY_IN_MS,
  });
};

export default useCalendarEventsQuery;
